import { useState, useEffect } from "react";
import { pendingDocumentsAPI } from "../services/api";

export const usePendingDocuments = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      console.log("🔄 Загружаем pending документы...");
      const response = await pendingDocumentsAPI.getAll();
      console.log("✅ Pending документы загружены:", response.data.documents);
      setDocuments(response.data.documents);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error("❌ Ошибка загрузки pending документов:", err);
      console.error("Детали:", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteDocument = async (id) => {
    try {
      await pendingDocumentsAPI.delete(id);
      await fetchDocuments();
    } catch (err) {
      console.error("Ошибка удаления документа:", err);
      throw err;
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  return { documents, loading, error, refetch: fetchDocuments, deleteDocument };
};
